module.exports = __webpack_public_path__ + "img/usb_1000.ce078d4c.png";